/**
 * Hero slideshow (sections/sus-hero.liquid).
 * Horizon's slideshow marks off-screen slides with aria-hidden but leaves their links and buttons
 * in the tab order. This makes those slides inert, so keyboard and screen reader users only reach
 * the slide that is showing.
 */
class SusHero extends HTMLElement {
  #observer = new MutationObserver(() => this.#syncInert());

  connectedCallback() {
    this.#syncInert();
    this.#observer.observe(this, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }

  disconnectedCallback() {
    this.#observer.disconnect();
  }

  #syncInert() {
    for (const slide of this.querySelectorAll('slideshow-slide')) {
      slide.inert = slide.getAttribute('aria-hidden') === 'true';
    }
  }
}

if (!customElements.get('sus-hero')) {
  customElements.define('sus-hero', SusHero);
}
